import { createSelector } from 'reselect';
import formQuestionId from '../../lib/utilityFunctions';
import * as curriculumSelectors from './curriculumSelectors';

export const isLastQuestion = state => state.questionIndex >= state.questionItemsInRound.length - 1;

export const getCurrentLevelId = state => state.levelIndex + 1;

export const getCurrentLevelIndex = state => state.levelIndex;

const getCurrentQuestionItem = state => state.questionItemsInRound[state.questionIndex];

export const getCurrentQuestionId = createSelector(
  [getCurrentQuestionItem],
  item => formQuestionId(item.schemaId, item.storyId),
);

export const getCurrentQuestionUuid = createSelector(
  [getCurrentQuestionItem],
  item => item.uuid,
);

export const getCurrentQuestionContentType = createSelector(
  [getCurrentQuestionItem],
  item => item.contentType,
);

export const getCurrentCorrectResponse = createSelector(
  [getCurrentQuestionItem],
  item => item.targetResponse,
);

export const getCurrentSchemaId = createSelector(
  [getCurrentQuestionItem],
  item => item.schemaId,
);

export const getCurrentStoryId = createSelector(
  [getCurrentQuestionItem],
  item => item.storyId,
);

export const getCurrentPossibleResponses = createSelector(
  [getCurrentQuestionItem],
  item => item.possibleResponses,
);

export const getCurrentPageIndex = state => state.pageIndex;

export const getCurrentQuestionIndex = state => state.questionIndex;

export const getGameMode = state => state.gameMode;

export const getIsSortingCreatedStory = state => state.isSortingCreatedStory;

export const getProgressPercentageInRound = state => state.progressAmount;

export const getResponseAttemptCount = state => state.responseAttemptCount;

export const getBatteryLifesCount = state => state.batteryLifesCount;

export const getSelectedResponse = state => state.selectedResponse;

export const getIntroScreenTextIndex = state => state.introScreenTextIndex;

export const getCurrentStory = createSelector(
  [getCurrentSchemaId, getCurrentStoryId],
  curriculumSelectors.getStory,
);

export const getCurrentStoryHints = createSelector(
  [getCurrentStory],
  story => story.hints,
);

export const getCurrentStoryPages = createSelector(
  [getCurrentSchemaId, getCurrentStoryId],
  curriculumSelectors.getStoryPages,
);

export const isLastPage = createSelector(
  [getCurrentStoryPages, getCurrentPageIndex],
  (storyPages, pageIndex) => pageIndex === storyPages.length - 1,
);
